module.exports = __webpack_public_path__ + "static/MTBLists_UL-OL_Spacing-8099f72b4cdca66cadfe80bfd587446d.png";